import { getData } from '@/views/dispatchs/dispatch/api/new-index'
import { getScheduleList } from '@/api/schedule'
import moment from 'moment'
const basicModel = 1800000
const state = {
  namespaced: true,
  state: {
    filterParams: {},
    scheduleList: [],
    columnList: [],
    loading: false,
    searchTimeMaxTime: 0,
    scrollLeft: 0,
    scrollTop: 0,
    searchForm: null,
    renderIndex: 0,
    showEvent: false,
    editEventInfo: {},
    loadDialogInfo: {}
  },
  mutations: {
    SET_FILTER_PARAMS(state, data) {
      state.filterParams = data
    },
    SET_LOAD_DIALOG_INFO(state, data) {
      state.loadDialogInfo = data
    },
    SET_EDIT_EVENT_INFO(state, data) {
      state.editEventInfo = data
    },
    SET_SHOW_EVENT(state, data) {
      state.showEvent = data
    },
    SET_SCHEDULE_LIST(state, data) {
      state.scheduleList = data || []
    },
    SET_COLUMN_LIST(state, data) {
      state.columnList = data || []
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_SCROLL_LEFT(state, data) {
      state.scrollLeft = data || 0
    },
    SET_SCROLL_TOP(state, data) {
      state.scrollTop = data || 0
    },
    SET_SEARCH_TIME_MAX_TIME(state, data) {
      state.searchTimeMaxTime = data
    },
    SET_SEARCH_FORM(state, data) {
      state.searchForm = data
    },
    SET_RENDER_INDEX(state, data) {
      state.renderIndex = data
    },
  },
  actions: {
    setLoadDialogInfo({ commit }, data) {
      console.log(data, 'event222')
      commit('SET_LOAD_DIALOG_INFO', data)
    },
    setShowEvent({ commit }, data) {
      console.log(data, 'event111')
      commit('SET_SHOW_EVENT', data)
      if (!data) {
        commit('SET_EDIT_EVENT_INFO', {})
        commit('SET_LOAD_DIALOG_INFO', {})
      }
    },
    setEditEventInfo({ commit }, data) {
      console.log(data, 'event333')
      commit('SET_EDIT_EVENT_INFO', data)
    },
    setScrollLeft({ commit }, data) {
      commit('SET_SCROLL_LEFT', data)
    },
    setRenderIndex({ commit }, data) {
      commit('SET_RENDER_INDEX', data)
    },
    setScrollTop({ commit }, data) {
      commit('SET_SCROLL_TOP', data)
    },
    setSearchForm( { commit }, data ) {
      commit('SET_SEARCH_FORM', data)
    },
    getScheduleList({ commit, dispatch }, params) {
      let max = 0
      if (params.dateFrom) {
        max = params.dateFrom + 604800000
      }
      commit('SET_SEARCH_TIME_MAX_TIME', Math.ceil(max / basicModel))
      dispatch('changeColumnList', [params.dateFrom, max])
      commit('SET_LOADING', true)
      params.dateTo = max
      getScheduleList(params).then(res => {
        const data = res.data
        console.log(data, 'data')
        let sourceList = []
        data.forEach(item => {
          if (item.secondlySchedules && item.teamSchedule) {
            item.teamSchedule.isTeam = true
            item.primarySchedules.isTeam = true
            item.secondlySchedules.isTeam = true
            item.teamSchedule.driverTeam = true
            let driverList = []
            let driver1 = {}
            driver1.name = item.primarySchedules.driverName
            driver1.driverId = item.primarySchedules.driverId
            driver1.location = item.primarySchedules.location
            driver1.status = item.primarySchedules.status
            driver1.driverPhone = item.primarySchedules.driverPhone
            let driver2 = {}
            driver2.name = item.secondlySchedules.driverName
            driver2.driverId = item.secondlySchedules.driverId
            driver2.location = item.secondlySchedules.location
            driver2.status = item.secondlySchedules.status
            driver2.driverPhone = item.secondlySchedules.driverPhone
            driverList.push(driver1, driver2)
            item.teamSchedule.driverList = driverList
            sourceList.push(item.teamSchedule)
            switch(item.teamSchedule.status) {
              case 'In Transit': 
                item.teamSchedule.status = 'in_transit'
                break
              case 'Inactive': 
                item.teamSchedule.status = 'inactive'
                break
            }
            item.teamSchedule.events && item.teamSchedule.events.forEach(it => {
              it.teamId = item.teamSchedule.teamId
              it.teamName = item.teamSchedule.name
              it.driverTeam = true
            })
          }
          sourceList.push(item.primarySchedules)
          if(item.secondlySchedules && item.teamSchedule) {
            sourceList.push(item.secondlySchedules)
          }
        })
        console.log(sourceList, 'isEvent')
        sourceList.forEach(item => {
          let maxTime = Math.ceil(max / basicModel)
          let minTime = Math.ceil(params.dateFrom / basicModel)
          // item.events = item.evens || []
          item.events && item.events.length && item.events.forEach(it => {
            it.isEvent = true
          })
          if (!item.loads) item.loads = []
          item.loads && (item.loads = item.loads.concat(item.events || []))
          item.loads && item.loads.forEach(it => {
            let end,start
            if (it.isEvent) {
              start = Math.ceil(it.eventFrom / basicModel)
              end = Math.ceil(it.eventTo / basicModel)
              it.end = Math.max(start, end)
            } else {
              it.viewTime = moment(it.pickupTime).format('YYYY MM DD')
              start = Math.ceil(it.pickupTime / basicModel)
              let time = it.deliveryTimeTo ? it.deliveryTimeTo : it.deliveryTime
              end = Math.ceil(time / basicModel)
              it.end = Math.max(start, end)
            }
            if (it.end > maxTime) {
              it.end = maxTime
            }
            it.start = Math.min(start, end)
            if (it.start < minTime) {
              it.start = minTime
            }
          })
          item.loads && item.loads.sort((a, b) => {
            if (a.start < b.start) {
              return -1
            } else if (a.start > b.start) {
              return 1
            }
            if (a.start == b.start) {
              if (a.end < b.end) {
                return -1
              } else {
                return 1
              }
            }
          })
        });
        console.log(data, 'schedule--')
        commit('SET_SCHEDULE_LIST', sourceList)
      }).finally(() => {
        commit('SET_LOADING', false)
      })
    },
    changeColumnList({ commit }, data) {
      let statrtTime = parseFloat(data[0])
      let endTime = parseFloat(data[1])
      let columnList = []
      columnList.push(Math.ceil(statrtTime / basicModel))
      while(statrtTime < endTime) {
        statrtTime = moment(statrtTime).add(1, 'days').format('x')
        statrtTime = parseFloat(statrtTime)
        if (statrtTime < endTime) {
          columnList.push(Math.ceil(statrtTime / basicModel))
        }
      }
      commit('SET_COLUMN_LIST', columnList)
      // console.log(this.columnList)
    },
    getData({ commit }) {
      return getData().then(res => {
        const data = res.data
        if(res.code === 200) {
          commit('SET_FILTER_PARAMS', data)
          console.log(data)
        }else {
          this.$message.error(res.message)
        }
      })
    }
  },
  modules: {
  },
  getters: {
    scheduleList: state => state.scheduleList,
    filterParams: state => state.filterParams,
    columnList: state => state.columnList,
    loading: state => state.loading,
    searchTimeMaxTime: state => state.searchTimeMaxTime,
    scrollLeft: state =>  state.scrollLeft,
    scrollTop: state =>  state.scrollTop,
    searchForm: state =>  state.searchForm,
    renderIndex: state =>  state.renderIndex,
    editEventInfo: state => state.editEventInfo,
    loadDialogInfo: state => state.loadDialogInfo,
    showEvent: state => state.showEvent,
  }
}

export default state
